/* eslint-disable import/prefer-default-export */
const CC_PLACEHOLDERS = {
  role: "Select a role",
  people: "Select...",
  email: "Enter Email Address",
};

export { CC_PLACEHOLDERS };